import React, {
	useContext,
	useState,
	useEffect,
	useRef,
	useCallback,
} from 'react';
import Seo from '../Seo/seo';
import {
	Row,
	Col,
	Container,
	Button,
	Spinner,
	ButtonGroup,
} from 'react-bootstrap';
import styled from 'styled-components';
import moment from 'moment';
import { Link } from 'gatsby';
import axios from 'axios';
import CustomContext from '../../../custom-context';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import Vimeo from '@vimeo/player';
import CustomMarkdown from '../../utils/CustomMarkdown';
import Banner from '../VisualComponents/topBannerPanel';
import { graphql, useStaticQuery } from 'gatsby';
import ImageComponent from '../../utils/imageComponent';
import { Lock as LockIcon } from '@styled-icons/fa-solid';
import ButtonComponent from '../../utils/ButtonComponent';
import BreadcrumbsComponent from '../../utils/BreadcrumbsComponent';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import {
	Viewer,
	Worker,
	SpecialZoomLevel,
	ViewMode,
} from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import LinkComponent from '../../utils/linkComponent';
import LockedBannerComponent from '../../utils/lockedBannerComponent';

const ResourceDetailStyled = styled.div`
	.viewport {
		height: calc(100vh - 10rem);
		width: 100%;
		margin-bottom: 1.5em;
	}
	.bannerContent {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: start;
		height: 100%;
		margin-left: 3em;
	}

	.resourceImage {
		width: 95%;
		aspect-ratio: 4/2.5;
		object-fit: cover;
		/* Caudit Beige */
		background-color: #f4f1ee;
	}

	/* Ipad and Ipad Pro */
	@media screen and (min-device-width: 481px) and (max-width: 1024px) {
		.resourceImage {
			width: 95%;
			/* height: 10em; */
		}
	}

	.image {
		margin-bottom: 2rem;
		/* width: -webkit-fill-available; */
		max-width: 100%;
		object-fit: cover;
		aspect-ratio: 4/2.5;
		border: 1px solid rgb(204, 204, 204);
	}

	.description {
		font-weight: 300;
		margin-bottom: 1em;
		line-height: 1.5em;
		font-size: var(--font-size-md);
	}

	.resource {
		padding-top: 3rem;
	}

	h1 {
		color: var(--primary);
		font-weight: 700;
		/*font-size: 2.5rem;*/
		font-size: var(--font-size-xl);
	}

	.connect {
		text-align: right;
		margin-top: 1rem;
		margin-bottom: 1rem;
	}

	.banner {
		width: 25em;
	}
	.bg {
		width: 9em;
	}

	.bannerTriangle {
		width: 43rem;
		height: 0;
		border: 170px solid transparent;
		border-top: 0;
		border-right: 190px solid white;
		margin-top: -2em;
		position: absolute;
		z-index: 2;
	}

	.bannerBottomTriangle {
		width: 43rem;
		height: 0;
		border: 150px solid transparent;
		border-top: 0;
		border-right: 190px solid white;
		margin-top: 8em;
		position: absolute;
		z-index: 2;
		transform: rotateX(180deg);
	}

	.bannerCol {
		padding: 0;
		display: flex;
		align-content: end;
		justify-content: left;
	}

	.attribute {
		font-family: 500;
		font-size: 1.1rem;
		text-transform: uppercase;
	}

	.mainContent {
		width: 90%;
	}

	.resourceDownload {
		margin-top: 2rem;
		margin-bottom: 3rem;
	}

	.attributeContainer {
		margin-bottom: 2rem;
	}

	.markdown img {
		width: 100%;
	}
	.markdown {
		overflow-wrap: break-word;
	}

	.image-gallery-icon:hover {
		color: var(--primary);
	}
	.image-gallery-thumbnail.active,
	.image-gallery-thumbnail:hover,
	.image-gallery-thumbnail:focus {
		border: 4px solid var(--primary);
	}

	.pdfViewer {
		height: 750px;
		/* width: 900px; */
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 1rem;
	}

	@media (max-width: 768px) {
		.bannerContent {
			padding: 1em;
			margin: 0;
			align-items: center;
			text-align: center;
		}

		.bannerTriangle {
			display: none;
		}

		.bannerBottomTriangle {
			display: none;
		}

		.transcript {
			margin-bottom: 2rem;
		}

		// .bannerTriangle {
		// 	border-right: 150px solid white;
		// }

		// .bannerBottomTriangle {
		// 	border-right: 120px solid white;
		// }

		.resource {
			padding-top: 0rem;
		}

		.description {
			margin-bottom: 0em;
		}
		h1 {
			font-size: 2rem;
		}

		.bg {
			display: none;
		}

		.mainContent {
			width: 100%;
		}

		.connect {
			text-align: left;
			margin-top: 1rem;
			margin-bottom: 1rem;
		}
		.banner {
			width: 18em;
		}

		h1 {
			margin-top: 1em;
		}
	}
`;

function ResourceDetail(props) {
	const resourceDetailBanner = useStaticQuery(graphql`
		query ResourceDetailQuery {
			strapiBanner {
				resource_details_banner {
					id
					strapi_id
					only_image
					image {
						localFile {
							childImageSharp {
								gatsbyImageData
							}
						}
					}
					content {
						title
						caption
						button {
							name
							link
						}
						design_options {
							background_colour
							font_colour
							text_align
							background_image {
								url
								localFile {
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
						image_side
					}
				}
			}
		}
	`);

	// Use resource from props or fetch via API
	const [resource, setResource] = useState(props.resource);
	const [activeResource, setActiveResource] = useState('');
	const [resourceImageSlider, setResourceImageSlider] = useState(null);
	const [loading, setLoading] = useStateCallback(false);
	const [fileButtonGroup, setFileButtonGroup] = useState({});
	const { token, handleLogout } = useContext(CustomContext);
	const [privateResource, setPrivateResource] = useState(props.privateResource);

	// react-pdf-viewer variables
	const transform = (slot) => ({
		...slot,
		Open: () => <></>,
		NumberOfPages: () => <>/ {slot.NumberOfPages()}</>,
		Download: (props) => (
			<div
				onClick={() => {
					window.analytics.track('Link Clicked', {
						strapi_id: resource
							? resource?.strapi_id
							: privateResource?.strapi_id,
						objectId: resource ? resource?.id : privateResource?.id,
						title: resource ? resource?.name : privateResource?.name,
						path: window.location.pathname,
						report_type: 'New',
						collection_type: 'Resource',
						static_component_title: 'Download Resource',
						url: window.location.href,
						strapi_id: resource
							? resource?.strapi_id
							: privateResource?.strapi_id,
					});
				}}
			>
				{slot.Download()}
			</div>
		),
	});

	const renderToolbar = (Toolbar) => (
		<Toolbar>
			{defaultLayoutPluginInstance.toolbarPluginInstance.renderDefaultToolbar(
				transform
			)}
		</Toolbar>
	);

	const defaultLayoutPluginInstance = defaultLayoutPlugin({
		renderToolbar,
		sidebarTabs: (defaultTabs) => [defaultTabs[0]],
	});

	// Update banner content based on whether the resource is private or public
	let banner;
	if (privateResource != null) {
		banner =
			resourceDetailBanner &&
			resourceDetailBanner.strapiBanner.resource_details_banner;
		resourceDetailBanner.strapiBanner.resource_details_banner.content.title =
			privateResource?.name;
		resourceDetailBanner.strapiBanner.resource_details_banner.content.caption =
			privateResource?.sub_heading;
	} else {
		banner =
			resourceDetailBanner &&
			resourceDetailBanner.strapiBanner.resource_details_banner;
		resourceDetailBanner.strapiBanner.resource_details_banner.content.title =
			resource?.name;
		resourceDetailBanner.strapiBanner.resource_details_banner.content.caption =
			resource?.sub_heading;
	}

	function useStateCallback(initialState) {
		const [state, setState] = useState(initialState);
		const cbRef = useRef(null);
		const setStateCallback = useCallback((state, cb) => {
			cbRef.current = cb;
			setState(state);
		}, []);
		useEffect(() => {
			if (cbRef.current) {
				cbRef.current(state);
				cbRef.current = null;
			}
		}, [state]);
		return [state, setStateCallback];
	}

	const containerRef = useRef();

	useEffect(() => {
		if (!token) {
			setResource(null);
		}
	}, [token]);

	useEffect(() => {
		if (resource) {
			var iframes = document.querySelectorAll('iframe');
			try {
				iframes.forEach((iframe) => {
					var player = new Vimeo(iframe);
					window.analytics.ready(function () {
						var VimeoAnalytics = window.analytics.plugins.VimeoAnalytics;
						window.analytics.register(VimeoAnalytics);
						var vimeoAnalytics = new VimeoAnalytics(
							player,
							'c7ab22279d452aabcbdc96c2fc28ffc9'
						);
						vimeoAnalytics.initialize();
					});
				});
			} catch (error) {
				setLoading(false);
			}
		}
	}, [resource]);

	useEffect(() => {
		if (!props.resource) {
			setLoading(true);
			if (token) {
				const resourceSlug = props.pageContext.slug;
				axios
					.get(`/api/get-resource`, {
						params: { resource: resourceSlug, token: token },
					})
					.then((response) => {
						response.data.pdfFiles = response.data?.files?.filter((item) =>
							item?.url.endsWith('pdf')
						);
						var buttonGroup = {};
						response.data?.pdfFiles?.forEach((item, index) => {
							var fileName = item.caption === '' ? item.name : item.caption;
							buttonGroup[fileName] = index === 0 ? 'danger' : 'secondary';
							if (index === 0) setActiveResource(item.url);
						});
						setFileButtonGroup(buttonGroup);
						response.data.notPdfFiles = response.data?.files?.filter(
							(item) => !item?.url.endsWith('pdf')
						);
						if (response.data?.image_slider?.length > 0) {
							var imageSlider = [];
							response.data?.image_slider.forEach((imageItem) =>
								imageSlider.push({
									original: imageItem.url,
									thumbnail: imageItem.formats.thumbnail.url,
									originalHeight: '350px',
									originalWidth: '600px',
								})
							);
							setResourceImageSlider(imageSlider);
						}
						setResource(response.data);
						setLoading(false);
					})
					.catch((error) => {
						console.log(error);
						console.log(error.response);
						if (
							error.response.status === 401 &&
							error.response.data.name === 'TokenExpiredError'
						) {
							handleLogout();
							setResource(null);
							setLoading(false);
						} else if (error.response.status === 401) {
							setResource(401);
							setLoading(false);
						} else {
							sessionStorage.setItem('returnURL', window.location.href);
						}
					});
			} else {
				setLoading(false);
			}
		} else {
			var resourceObject = JSON.parse(JSON.stringify(props.resource));
			resourceObject.pdfFiles = resourceObject.files?.filter((item) =>
				item?.url.endsWith('pdf')
			);
			var buttonGroup = {};
			resourceObject.pdfFiles?.forEach((item, index) => {
				var fileName = item.caption === '' ? item.name : item.caption;
				buttonGroup[fileName] = index === 0 ? 'danger' : 'secondary';
				if (index === 0) setActiveResource(item.url);
			});
			setFileButtonGroup(buttonGroup);
			resourceObject.notPdfFiles = resourceObject.files?.filter(
				(item) => !item?.url.endsWith('pdf')
			);
			if (resourceObject.image_slider?.length > 0) {
				var imageSlider = [];
				resourceObject.image_slider.forEach((imageItem) =>
					imageSlider.push({
						original: imageItem.url,
						thumbnail: imageItem.formats.thumbnail.url,
						originalHeight: '350px',
						originalWidth: '600px',
					})
				);
				setResourceImageSlider(imageSlider);
			}
			setResource(resourceObject);
			window.analytics.page(`${process.env.GATSBY_WEBSITE_NAME} Resources`, {
				title: resourceObject.name,
				name: 'View Resource Page',
			});
			setResource(resourceObject);
			setLoading(false);
		}
		window.analytics.page('Detail', 'Resources', {
			path: window.location.pathname,
			property: {
				logged_in_status: token ? 'logged-in' : 'not logged-in',
			},
			report_type: 'New',
			strapi_id: resource ? resource?.strapi_id : null,
			title: resource ? resource?.name : null,
			url: window.location.href,
			objectId: resource ? resource?.id : null,
		});
	}, [props, token, containerRef]);

	function changePDF(params) {
		var newFileButtonGroup = {};
		resource.pdfFiles.forEach((item) => {
			var fileName = item.caption === '' ? item.name : item.caption;
			newFileButtonGroup[fileName] = 'secondary';
		});
		var fileName = params.caption === '' ? params.name : params.caption;
		newFileButtonGroup[fileName] = 'danger';
		setFileButtonGroup(newFileButtonGroup);
		setActiveResource(params.url);
	}

	if (loading)
		return (
			<ResourceDetailStyled>
				<BreadcrumbsComponent
					title={resource?.name ? resource?.name : ''}
					titleArray={['Resources', resource?.name ? resource?.name : '']}
					path={props.path}
				/>
				<Container
					style={{
						textAlign: 'center',
						marginTop: '4.5em',
						marginBottom: '4.5em',
					}}
				>
					<Spinner animation='border' />
					<h2> Loading the resource</h2>
				</Container>
			</ResourceDetailStyled>
		);

	if (!token && !resource && privateResource)
		return (
			<ResourceDetailStyled style={{ overflowX: 'hidden' }}>
				<div>
					<Banner content={banner} title='Resources'></Banner>
				</div>
				<BreadcrumbsComponent
					title={privateResource.name}
					titleArray={['Resources', privateResource.name]}
					path={props.path}
				/>
				<Container>
					<Row className='resource'>
						<Col
							xs={12}
							md={privateResource.show_attributes === false ? 12 : 9}
							lg={privateResource.show_attributes === false ? 12 : 9}
						>
							<main>
								<div>
									<p>
										{privateResource?.short_description
											? privateResource?.short_description
											: ''}
									</p>
									{privateResource?.name ===
										'2024 State of ICT IT Investment and Staffing Report v1.0' && (
										<p>
											View State of ICT ANZ Universities Snapshot{' '}
											<a
												href='https://www.caudit.edu.au/insights/benchmarking/snapshot/'
												target='_blank'
												rel='noopener noreferrer'
											>
												here.
											</a>{' '}
										</p>
									)}
								</div>
								<LockedBannerComponent></LockedBannerComponent>
							</main>
						</Col>
						{privateResource.show_attributes === true ||
						privateResource.show_attributes === null ? (
							<Col sm={12} md={3} lg={3}>
								{privateResource.header_image !== null ? (
									<ImageComponent
										imageItem={privateResource.header_image}
										className='image'
										alt='Resource Image'
									></ImageComponent>
								) : (
									''
								)}
								{privateResource.authored_date ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>Original Publish Date</h3>
										<p>
											{moment(privateResource.authored_date).format(
												'DD MMM YYYY'
											)}
										</p>
									</div>
								) : (
									''
								)}
								{privateResource.topics ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>
											{privateResource.topics?.length > 0
												? privateResource.topics.length > 1
													? 'Topics'
													: 'Topic'
												: ''}
										</h3>
										<p>
											{privateResource.topics.map((item, index) => {
												return <div key={index}>{item.name}</div>;
											})}{' '}
										</p>
									</div>
								) : (
									''
								)}
								{privateResource.resource_type ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>Resource Type</h3>
										<span>{privateResource.resource_type?.name}</span>
									</div>
								) : (
									''
								)}
								{privateResource.people ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>
											{privateResource.people?.length > 0
												? privateResource.people?.length > 1
													? 'Authors'
													: 'Author'
												: ''}
										</h3>
										<p>
											{privateResource.people?.map((item, index) => {
												return (
													<div key={index}>
														<LinkComponent
															to={`/people/${item.slug ? item.slug : ''}`}
														>
															{item.first_name} {item.last_name}
														</LinkComponent>
													</div>
												);
											})}{' '}
										</p>
									</div>
								) : (
									''
								)}
								{privateResource.resource_tags ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>
											{privateResource.resource_tags.length > 0
												? privateResource.resource_tags.length > 1
													? 'Tags'
													: 'Tag'
												: ''}
										</h3>
										<p>
											{privateResource.resource_tags?.map((item, index) => {
												return <div key={index}>{item.name}</div>;
											})}{' '}
										</p>
									</div>
								) : (
									''
								)}
								{/* Update procurement offer link to use the hub */}
								{privateResource.vendor_offer ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>Procurement Offer</h3>
										<a href={`/procurement/portal`}>
											{privateResource.vendor_offer.name}
										</a>
									</div>
								) : (
									''
								)}
								{/* Update procurement panel link to use the hub */}
								{privateResource.procurement_panel ? (
									<div className='attributeContainer'>
										<h3 className='attribute'>Procurement Panel</h3>
										<a href={`/procurement/portal`}>
											{privateResource.procurement_panel.name}
										</a>
									</div>
								) : (
									''
								)}
								{privateResource.additional_attributes ? (
									<div className='attributeContainer'>
										{privateResource.additional_attributes?.map(
											(item, index) => {
												return (
													<div key={index}>
														<h3 className='attribute'>{item.title}</h3>
														<p>{item.value}</p>
													</div>
												);
											}
										)}{' '}
									</div>
								) : (
									''
								)}
							</Col>
						) : null}
					</Row>
				</Container>
			</ResourceDetailStyled>
		);
	if (resource === 401)
		return (
			<ResourceDetailStyled>
				<BreadcrumbsComponent
					title={privateResource?.name ? privateResource?.name : ''}
					titleArray={[
						'Resources',
						privateResource.name ? privateResource.name : '',
					]}
					path={props.path}
				/>
				<Container style={{ textAlign: 'center', margin: '4.5em' }}>
					<h2>You do not have permission to access this resource</h2>
				</Container>
			</ResourceDetailStyled>
		);
	if (resource)
		return (
			<ResourceDetailStyled>
				<div>
					<Banner content={banner} title='Resources'></Banner>
				</div>
				<BreadcrumbsComponent
					title={resource.name}
					titleArray={['Resources', resource.name]}
					path={props.path}
				/>
				<Worker workerUrl='https://unpkg.com/pdfjs-dist@3.10.111/build/pdf.worker.js'>
					<Container>
						<Row className='resource'>
							<Col
								xs={12}
								md={resource.show_attributes === false ? 12 : 9}
								lg={resource.show_attributes === false ? 12 : 9}
							>
								<main>
									{resourceImageSlider ? (
										<ImageGallery items={resourceImageSlider} />
									) : null}
									<p className='mainContent'>
										<CustomMarkdown
											children={
												resource?.body_content?.data?.childMarkdownRemark?.html
													? resource?.body_content?.data?.childMarkdownRemark
															?.html
													: ''
											}
											className='markdown'
										/>
									</p>

									{/* Download Button for NON PDF files */}
									{resource.notPdfFiles?.length > 0 ? (
										<div className='resourceDownload'>
											<h3>
												Resource download link
												{resource.notPdfFiles?.length > 1 ? 's' : null}
											</h3>
											<div>
												{resource.notPdfFiles?.map((item, index) => {
													return (
														<div style={{ marginTop: '1em' }} key={index}>
															<LinkComponent
																to={item?.url}
																target='_blank'
																onClick={() => {
																	window.analytics.track('Link Clicked', {
																		title: resource ? resource?.name : '',
																		path: window.location.pathname,
																		report_type: 'New',
																		collection_type: 'Resource',
																		static_component_title: 'Download Resource',
																		url: window.location.href,
																		obhectId: resource ? resource?.id : '',
																		strapi_id: resource
																			? resource?.strapi_id
																			: '',
																	});
																}}
															>
																<ButtonComponent
																	analyticsTrackTitle='Resource Download Button'
																	analyticsTitle={
																		resource.name + ' - Download Button Clicked'
																	}
																	windowLocationHref={
																		typeof window !== 'undefined' &&
																		window.location.href
																	}
																	buttonName={
																		item.caption === ''
																			? item.name === ''
																				? 'Download Resource'
																				: item.name
																			: item.caption
																	}
																	iconVisible={true}
																/>
															</LinkComponent>
														</div>
													);
												})}{' '}
											</div>
										</div>
									) : (
										''
									)}

									{resource.pdfFiles?.length > 0 ? (
										<hr
											style={{
												borderTop: '1px var(--primary) solid',
												opacity: '1',
											}}
										/>
									) : null}
									{resource.pdfFiles?.length === 1
										? null
										: resource.pdfFiles?.length > 0
										? resource.pdfFiles?.map((item, index) => {
												return (
													<ButtonGroup aria-label='PDF Files' key={index}>
														<Button
															onClick={() => changePDF(item)}
															variant={
																fileButtonGroup[
																	item.caption === '' ? item.name : item.caption
																]
															}
															style={{
																margin: '0.5em 0.5em',
																fontSize: 'var(--font-size-base)',
															}}
														>
															{item.caption === ''
																? item.name === ''
																	? 'View PDF'
																	: item?.name.substring(
																			0,
																			item.name.length - 4
																	  )
																: item.caption}
														</Button>
													</ButtonGroup>
												);
										  })
										: null}
									{resource.pdfFiles?.length > 0 ? (
										<div className='pdfViewer'>
											<Viewer
												defaultScale={SpecialZoomLevel.PageWidth}
												fileUrl={activeResource}
												viewMode={
													resource.name === '2023 CAUDIT Annual Report' ||
													resource.name === '2023 Year in Review' ||
													resource.name === 'CAUDIT 2024 Top Ten' ||
													resource.name === 'CAUDIT Annual Report 2024'
														? ViewMode.DualPageWithCover
														: ViewMode.SinglePage
												}
												plugins={[defaultLayoutPluginInstance]}
											/>
										</div>
									) : null}
									{resource.transcript?.data?.childMarkdownRemark?.html ? (
										<div className='transcript'>
											<h2>Transcript</h2>
											<CustomMarkdown
												children={
													resource.transcript.data?.childMarkdownRemark.html
														? resource.transcript.data.childMarkdownRemark.html
														: ''
												}
												className='markdown'
											/>
										</div>
									) : (
										''
									)}
								</main>
							</Col>
							{resource.show_attributes === true ||
							resource.show_attributes === null ? (
								<Col xs={12} md={3} lg={3}>
									{resource.header_image ? (
										<ImageComponent
											imageItem={resource.header_image}
											className='image'
											alt='Resource Image'
										/>
									) : (
										''
									)}
									{resource.authored_date ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>Original Publish Date</h3>
											<p>
												{moment(resource.authored_date).format('DD MMM YYYY')}
											</p>
										</div>
									) : (
										''
									)}
									{resource.topics ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>
												{resource.topics?.length > 0
													? resource.topics.length > 1
														? 'Topics'
														: 'Topic'
													: ''}
											</h3>
											<p>
												{resource.topics.map((item, index) => {
													return <div key={index}>{item.name}</div>;
												})}{' '}
											</p>
										</div>
									) : (
										''
									)}
									{resource.resource_type ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>Resource Type</h3>
											<span>{resource.resource_type?.name}</span>
										</div>
									) : (
										''
									)}
									{resource.people ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>
												{resource.people?.length > 0
													? resource.people?.length > 1
														? 'Authors'
														: 'Author'
													: ''}
											</h3>
											<p>
												{resource.people?.map((item, index) => {
													return (
														<div key={index}>
															<LinkComponent
																to={`/people/${item.slug ? item.slug : ''}`}
															>
																{item.first_name} {item.last_name}
															</LinkComponent>
														</div>
													);
												})}{' '}
											</p>
										</div>
									) : (
										''
									)}
									{resource.resource_tags ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>
												{resource.resource_tags.length > 0
													? resource.resource_tags.length > 1
														? 'Tags'
														: 'Tag'
													: ''}
											</h3>
											<p>
												{resource.resource_tags?.map((item, index) => {
													return <div key={index}>{item.name}</div>;
												})}{' '}
											</p>
										</div>
									) : (
										''
									)}
									{/* Update procurement offer link to point to the hub */}
									{resource.vendor_offer ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>Procurement Offer</h3>
											<a href={`/procurement/portal`}>
												{resource.vendor_offer.name}
											</a>
										</div>
									) : (
										''
									)}
									{/* Update procurement panel link to point to the hub */}
									{resource.procurement_panel ? (
										<div className='attributeContainer'>
											<h3 className='attribute'>Procurement Panel</h3>
											<a href={`/procurement/portal`}>
												{resource.procurement_panel.name}
											</a>
										</div>
									) : (
										''
									)}
									{resource.additional_attributes ? (
										<div className='attributeContainer'>
											{resource.additional_attributes?.map((item, index) => {
												return (
													<div key={index}>
														<h3 className='attribute'>{item.title}</h3>
														{item?.value?.startsWith('http') ? (
															<LinkComponent to={item.value}>
																{item.value}
															</LinkComponent>
														) : (
															<p>{item.value}</p>
														)}
													</div>
												);
											})}{' '}
										</div>
									) : (
										''
									)}
								</Col>
							) : null}
						</Row>
					</Container>
				</Worker>
				{resource.seo && (
					<Seo
						title={resource.seo?.metaTitle || resource.name || null}
						name='Viewed Resource'
						description={
							resource.seo?.metaDescription ||
							resource.short_description ||
							null
						}
						keywords={
							resource.seo?.keywords || resource.search_keywords || null
						}
						image={
							resource.seo?.metaImage?.url || resource.header_image?.url || null
						}
						slug={`/resources/${resource.slug}`}
					/>
				)}
			</ResourceDetailStyled>
		);
}
export default ResourceDetail;
